const isMobile = () => window.innerWidth < 756;

export default isMobile;
